import HrCalendarPg from "../HR/HrCalendarPg";

function ITACalendarPg() {
  return <HrCalendarPg readOnly />;
}

export default ITACalendarPg;
